<template>
  <modal>
    <template slot="modal-header">
      <div class="header-wrapper">
        <h2 class="section-heading">
          <template v-if="userId"
            >Edit user</template
          >
          <template v-else
            >Create new user</template
          >
        </h2>
        <close-button @closeModal="closeModal"></close-button>
      </div>
    </template>
    <template slot="modal-body">
      <vue-form :state="formState" name="userForm" @submit.prevent="">
        <div class="col-12">
          <div class="form-row">
            <validate class="form-group col-12 col-sm-6">
              <field-messages class="invalid-feedback" name="fname" show="$dirty && $invalid">
                <div slot="required">First name is required</div>
              </field-messages>
              <input
                type="text"
                required
                name="fname"
                class="form-control"
                v-model.trim="user.firstName"
              />
              <label>First name *</label>
            </validate>
            <validate class="form-group col-12 col-sm-6">
              <field-messages class="invalid-feedback" name="lname" show="$dirty && $invalid">
                <div slot="required">Last name is required</div>
              </field-messages>
              <input
                type="text"
                required
                name="lname"
                class="form-control"
                v-model.trim="user.lastName"
              />
              <label>Last name *</label>
            </validate>
          </div>
          <div class="form-row">
            <validate class="form-group col-12 col-sm-6">
              <field-messages class="invalid-feedback" name="email" show="$dirty && $invalid">
                <div slot="required">Email is required</div>
                <div slot="email">Email is invalid</div>
              </field-messages>
              <input
                type="email"
                required
                :disabled="user.id"
                name="email"
                class="form-control"
                v-model.trim="user.email"
              />
              <label>Email *</label>
            </validate>
            <validate class="form-group col-12 col-sm-6">
              <field-messages class="invalid-feedback" name="roles" show="$dirty && $invalid">
                <div slot="required">Role is required</div>
              </field-messages>
              <select id="roles" class="custom-select" v-model="user.role" name="roles" required>
                <template v-for="role in roles">
                  <option :value="role.value" :key="role.value">{{ role.name }}</option>
                </template>
              </select>
              <label>Role *</label>
            </validate>
            <div class="form-group col-12 col-sm-12" v-if="showClients">
              <select class="custom-select" v-model="user.selectedClient.id">
                <template v-for="client in clients">
                  <option :value="client.id" :key="client.id">{{ client.title }}</option>
                </template>
              </select>
              <label>Client <span class="text-light"></span></label>
            </div>
            <div class="form-row col-12 col-sm-12" v-if="showAgencies">
              <label class="col-12">OFFICES <span class="text-light"></span></label>
              <div
                class="col-12 col-sm-4 c__checkbox"
                v-for="agency in filteredAgencies"
                :key="agency.id"
              >
                <input type="checkbox" :value="agency.id" v-model="user.selectedPermissions" />
                <label>{{ agency.displayName }}</label>
              </div>
            </div>
            <validate class="form-row col-12 col-sm-12" v-if="isAgentUser">
              <label class="col-12">OFFICE * <span class="text-light"></span></label>
              <select
                class="custom-select"
                v-model="selectedSingleAgencyId"
                required
                name="singleOffice"
              >
                <template v-for="agency in filteredAgencies">
                  <option :value="agency.id" :key="agency.id">
                    {{ agency.displayName }}
                  </option>
                </template>
              </select>
              <field-messages
                class="invalid-feedback"
                name="singleOffice"
                show="$dirty && $invalid"
              >
                <div slot="required">Office is required</div>
              </field-messages>
            </validate>
          </div>
          <div class="form-group"></div>
          <div class="form-row" v-if="isAgentUser">
            <div class="form-group col-6 col-sm-6">
              <input
                type="email"
                required
                name="mobile"
                class="form-control"
                v-model.trim="user.mobile"
              />
              <label>Mobile</label>
            </div>
            <div class="form-group col-6 col-sm-6">
              <input
                type="text"
                required
                name="destinationUrl"
                class="form-control"
                v-model.trim="user.destinationUrl"
              />
              <label>Destination URL</label>
            </div>
          </div>
          <div class="form-row">
            <div class="col-6">
              <div class="form-group col-12 col-sm-4 no-side-pad">
                <label><small class="text-light">(Max: 1mb JPG, PNG, GIF, SVG)</small></label>
                <logo-upload
                  :logo="user.imageOriginal"
                  label="Image"
                  ref="userImage"
                  :displayLabel="false"
                />
                <div class="error" v-if="agentImageSizeError">
                  Agent Image must be 1MB Max Size
                </div>
              </div>
            </div>
            <validate class="col-6 col-sm-6" v-if="isAgentUser">
              <div class="form-group col-12 col-sm-12 no-side-pad">
                <field-messages class="invalid-feedback" name="postcode" show="$dirty && $invalid">
                  <div slot="minlength">Minimum 4 Territory Postcodes</div>
                  <div slot="pattern">Postcode must be a comma-separated</div>
                </field-messages>
                <input
                  type="text"
                  name="postcode"
                  class="form-control"
                  v-model="user.postcode"
                  minlength="4"
                  pattern="^(\d+(,\s*\d+)*,?\s*)?$"
                />
                <label>Postcode</label>
              </div>
            </validate>
          </div>
        </div>
        <div class="modal-footer">
          <div>
            <button
              class="btn btn-tertiary"
              v-if="user.id && $isAllowed('archive')"
              @click="
                deleteAction(
                  `Are you sure you want to archive ${user.firstName} ${user.lastName}?`,
                  'Archive'
                )
              "
            >
              Archive
            </button>
          </div>
          <div class="c__btn--container">
            <button class="btn btn-primary" v-if="user.id" @click="updateUser">
              Save
            </button>
            <button class="btn btn-primary" v-else @click="createUser">Save</button>
          </div>
        </div>
      </vue-form>
      <result-message :errors="errors"></result-message>
    </template>
  </modal>
</template>

<script>
import Modal from "../../helpers/Modal";
import CloseButton from "../../helpers/CloseButton";
import ResultMessage from "../../helpers/ResultMessage";
import UserServices from "../../services/users";
import AgencyServices from "../../services/agencies";
import ClientServices from "../../services/clients";
import DeleteAction from "../../mixins/DeleteAction";
import LogoUpload from "../../helpers/LogoUpload";
import FileServices from "../../services/files";
import UserPerimeter from "../../configs/Perimeters/users";

export default {
  name: "ModalUser",
  perimeters: [UserPerimeter],
  mixins: [DeleteAction],
  props: ["userId", "agencyId", "clientIds"],
  components: {
    ResultMessage,
    Modal,
    CloseButton,
    LogoUpload
  },
  computed: {
    isAgentUser: function() {
      return this.user.role === "ROLE_AGENT_USER";
    },
    showAgencies: function() {
      return this.user.role === "ROLE_AGENT_ADMIN";
    },
    showClients: function() {
      return this.user.role === "ROLE_CLIENT_ADMIN" || this.user.role === "ROLE_AGENT_ADMIN";
    },
    filteredAgencies: function() {
      return this.agencies.filter(agency => {
        return agency.client && agency.client.id === this.user.selectedClient.id;
      });
    }
  },
  data() {
    return {
      formState: {},
      roles: [],
      agencies: [],
      clients: [],
      user: {
        role: {},
        selectedPermissions: [],
        selectedClient: {
          id: null
        }
      },
      errors: {
        type: Object | Error,
        $clean: true
      },
      agentImageSizeError: false,
      selectedSingleAgencyId: null
    };
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
    getRoles() {
      this.roles = [
        {
          name: "Client Admin",
          value: "ROLE_CLIENT_ADMIN"
        },
        {
          name: "Today Admin",
          value: "ROLE_ADMIN"
        },
        {
          name: "Office Admin",
          value: "ROLE_AGENT_ADMIN"
        },
        {
          name: "Agent",
          value: "ROLE_AGENT_USER"
        }
      ];
      let vue = this;
      UserServices.getRoles().then(allowedRoles => {
        vue.roles = vue.roles.filter(function(value, index, arr) {
          return allowedRoles.includes(value.value);
        });
      });
    },
    getAgencies() {
      AgencyServices.getAgencies("published", "client", "", null, null, -1).then(agencies => {
        this.agencies = agencies.data;
      });
    },
    getClients(status) {
      ClientServices.getClients(status).then(clients => {
        this.clients = clients.data;
      });
    },
    getUser() {
      UserServices.getUser(this.userId, "client,clients").then(user => {
        this.user = user;
        let self = this;
        this.user.selectedPermissions = [];
        this.user.selectedClient = {};
        this.user.role = this.user.role.value;
        this.selectedSingleAgencyId = null;
        if (typeof this.user.permissions !== "undefined") {
          this.user.permissions.forEach(function(permission) {
            self.user.selectedPermissions.push(permission.agency);
            self.selectedSingleAgencyId = permission.agency;
          });
        }
        if (typeof this.user.client !== "undefined") {
          self.user.selectedClient = this.user.client;
        }

        if (this.user.postcode) {
          let postcode = this.user.postcode.replace(/,\s*/g, ", ");
          postcode = postcode.replace(/(\d{4})(?=\d)(?!,)/g, "$1, ");
          this.user.postcode = postcode;
        }
      });
    },
    deleteItem() {
      UserServices.archiveUser(this.user.id)
        .then(user => {
          this.user = user.data;
          this.$emit("closeModal");
        })
        .catch(errors => {
          this.errors = errors;
        });
    },
    async updateUser() {
      if (this.formState.$invalid) {
        // Mark any fields as dirty that might not have been touched so that errors appear
        this.formState.$error
          ? Object.entries(this.formState.$error).forEach(entry => {
              entry[1].$dirty = true;
            })
          : null;
        return;
      }
      if (this.userImageError()) {
        return;
      }
      await this.uploadUserImage();
      if (this.user.role === "ROLE_AGENT_USER" && this.selectedSingleAgencyId) {
        this.user.selectedPermissions = [];
        this.user.selectedPermissions.push(this.selectedSingleAgencyId);
      }
      UserServices.setAgencies(this.agencies)
        .updateUser(this.user)
        .then(() => {
          this.$emit("closeModal");
        })
        .catch(errors => {
          this.errors = errors;
        });
    },
    async createUser() {
      if (this.formState.$invalid) {
        // Mark any fields as dirty that might not have been touched so that errors appear
        this.formState.$error
          ? Object.entries(this.formState.$error).forEach(entry => {
              entry[1].$dirty = true;
            })
          : null;
        return;
      }
      this.user.username = this.user.email;
      if (this.userImageError()) {
        return;
      }
      await this.uploadUserImage();
      if (this.user.role === "ROLE_AGENT_USER" && this.selectedSingleAgencyId) {
        this.user.selectedPermissions = [];
        this.user.selectedPermissions.push(this.selectedSingleAgencyId);
      }
      UserServices.setAgencies(this.agencies)
        .createUser(this.user)
        .then(response => {
          // Set user id just in case its a new user
          this.user.id = response.id;
          this.$emit("closeModal");
        })
        .catch(errors => {
          this.errors = errors;
        });
    },
    userImageError() {
      this.agentImageSizeError = false;
      if (this.$refs.userImage) {
        if (this.$refs.userImage.uploadFile.size > 1024000) {
          this.agentImageSizeError = true;
        }
      }
      return this.agentImageSizeError;
    },
    async uploadUserImage() {
      let formData = null;
      if (this.$refs.userImage && typeof this.$refs.userImage.uploadFile.size !== "undefined") {
        formData = new FormData();
        formData.append("image", this.$refs.userImage.uploadFile);
        formData.append("subType", "agent original");
      } else if (this.user.imageOriginal && this.user.imageOriginal.id) {
        this.user.imageOriginal = this.user.imageOriginal.id;
      }

      if (formData) {
        await FileServices.uploadFile(formData)
          .then(userImage => {
            this.user.imageOriginal = userImage.id;
          })
          .catch(errors => {
            this.errors = errors;
          });
      }
    }
  },
  mounted() {
    this.getRoles();
    this.getAgencies();
    this.getClients("published");
    if (null !== this.userId) {
      this.getUser();
    } else {
      this.user.selectedClient.id = this.clientIds[0];
    }
  }
};
</script>
